export default __webpack_public_path__ + "static/media/institute-22-min.7b86a165.webp";